// extracted by mini-css-extract-plugin
module.exports = {"header":"header-styles-module--header--SVIWL","float":"header-styles-module--float--1vpQO"};